import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { WorkspaceProvider } from "@/context/WorkspaceContext";
import { DateRangeProvider } from "@/context/DateRangeContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import SKUs from "@/pages/SKUs";
import SalesLog from "@/pages/SalesLog";
import Workspaces from "@/pages/Workspaces";
import Orders from "@/pages/Orders";
import WeeklyReport from "@/pages/WeeklyReport";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground text-sm" data-testid="app-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <WorkspaceProvider>
          <DateRangeProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/report/weekly" element={<Protected><WeeklyReport /></Protected>} />
                <Route element={<Protected><Layout /></Protected>}>
                  <Route index element={<Dashboard />} />
                  <Route path="skus" element={<SKUs />} />
                  <Route path="sales-log" element={<SalesLog />} />
                  <Route path="orders" element={<Orders />} />
                  <Route path="workspaces" element={<Workspaces />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </div>
          </DateRangeProvider>
        </WorkspaceProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
